import { render } from "./StockAvailabilityDialog.vue?vue&type=template&id=36da4ba9&scoped=true"
import script from "./StockAvailabilityDialog.vue?vue&type=script&lang=js"
export * from "./StockAvailabilityDialog.vue?vue&type=script&lang=js"

import "./StockAvailabilityDialog.vue?vue&type=style&index=0&id=36da4ba9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36da4ba9"]])

export default __exports__